module.exports = __webpack_public_path__ + "static/img/neutre_shadow.bde146b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/neutre_shadow.png
// module id = 2eDO
// module chunks = 0